/* eslint-disable import/first */
import React from 'react';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/browser';

// b/c draft-js (by facebook) is also abandoned (like create-react-app)
// and it assumes window.global we need to explicitly define it
// https://stackoverflow.com/a/73208485
window.global ||=  window;

import './styles/css/base.css';
import App from './App';

import { getEnv } from 'utils/env';


const SENTRY_DSN = getEnv('REACT_APP_SENTRY_DSN');

const VERSION = getEnv('REACT_APP_VERSION', 'unknown');
const ENVIRONMENT = getEnv('REACT_APP_ENVIRONMENT', 'dev');
const ignoreErrors = [
    'APIError',
    /Failed to fetch dynamically imported module/,
    /Importing a module script failed/,
    /ttd_dom_ready is not defined/,
    /Invalid call to runtime.sendMessage/,
];


if (SENTRY_DSN) {
    Sentry.init({
        dsn: SENTRY_DSN,
        release: `portal@${VERSION}`,
        environment: ENVIRONMENT,
        ignoreErrors: ignoreErrors,
        integrations: [
            Sentry.captureConsoleIntegration({
                levels: ['error'],
            }),
            Sentry.thirdPartyErrorFilterIntegration({
                filterKeys: ['portal-client'],
                behaviour: 'drop-error-if-contains-third-party-frames',
            }),
        ],
    });
}

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<App />);
